document.body.style.zoom = "75%";
